import CalendarItemNotificationPayload from 'owa-service/lib/contract/CalendarItemNotificationPayload';
import CalendarItemNotificationPayloadExtended from '../store/CalendarItemNotificationPayloadExtended';
import debounce from 'lodash-es/debounce';
import getDateRange from '../../store/apis/getDateRange';
import handleRecurringItemNotification from './internal/handleRecurringItemNotification';
import handleReloadNotification from './internal/handleReloadNotification';
import handleRowDeletedNotification from './internal/handleRowDeletedNotification';
import handleSingleItemNotification from './internal/handleSingleItemNotification';
import traceNotificationData from '../utils/traceNotificationData';
import { getNotificationsQueue } from '../store/store';

/**
 * How long we'll wait to process notifications after they arrive
 */
const ProcessNotificationAfterMilliseconds = 2 * 1000;

/**
 * Enqueue the new notification received and invoke the debounced handler
 */
export default function handleCalendarItemNotification(
    folderId: string,
    notification: CalendarItemNotificationPayload
) {
    !notification.FolderId && (notification.FolderId = folderId);
    traceNotificationData(notification, true);
    const extendedNotification: CalendarItemNotificationPayloadExtended = new CalendarItemNotificationPayloadExtended(
        notification
    );
    const notificationsQueue = getNotificationsQueue();
    notificationsQueue.enqueueNotification(extendedNotification);
    debounceDrainNotificationQueue();
}

/**
 * Debounce logic
 */
const debounceDrainNotificationQueue = debounce(
    drainNotificationQueue,
    ProcessNotificationAfterMilliseconds
);

/**
 * Drains the Notification queue and processes each item in the queue
 */
function drainNotificationQueue() {
    getNotificationsQueue().processQueue(handleNotification);
}

/**
 * Handles a notification
 */
function handleNotification(notification: CalendarItemNotificationPayloadExtended) {
    const { NotificationPayload } = notification;
    traceNotificationData(NotificationPayload, false);
    if (notification.isReloadNotification()) {
        handleReloadNotification(notification.NotificationPayload.FolderId);
    } else {
        if (!!getDateRange()) {
            if (notification.isRowDeletedNotification()) {
                handleRowDeletedNotification(NotificationPayload);
            } else if (notification.isRecurringMaster()) {
                handleRecurringItemNotification(NotificationPayload.FolderId, notification);
            } else {
                handleSingleItemNotification(NotificationPayload);
            }
        }
    }
}
